  //Function to extract the Two letters from the Names if avtar image is not present
  function extractInitials(nameString) {
    if (nameString) {
      let parts = nameString.includes(" ")
        ? nameString.trim().split(" ")
        : [nameString];
      if (parts.length === 1) {
        return parts[0].substring(0, 2).toUpperCase();
      } else if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
    }
  }


  export {extractInitials}